import { render } from "./NeedsToAddClientBanner.vue?vue&type=template&id=a61ab0be&scoped=true"
import script from "./NeedsToAddClientBanner.vue?vue&type=script&lang=js"
export * from "./NeedsToAddClientBanner.vue?vue&type=script&lang=js"

import "./NeedsToAddClientBanner.vue?vue&type=style&index=0&id=a61ab0be&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a61ab0be"]])

export default __exports__